import React, { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import { SportEntitiesData } from '@utils/entities'

import FmTCompetitorsList from './FmTCompetitorsList'

interface GroupedCompetitorsItemProps {
  competitionTitle?: string
  competitorsListData: SportEntitiesData
}

const StyledGroupedList = styled.div`
  display: flex;
  flex-direction: column;
`
const StyledCompetitionTitle = styled.div`
  ${({
    theme: {
      typography: {
        catchword: {
          medium2: { bundledCSS: catchwordMedium2CSS },
        },
      },
      colors: { textDefault },
    },
  }) => css`
    ${catchwordMedium2CSS};
    text-transform: uppercase;
    color: ${textDefault};
  `}
`

const GroupedCompetitorsItem: FunctionComponent<
  GroupedCompetitorsItemProps
> = ({ competitionTitle, competitorsListData }) => (
  <StyledGroupedList>
    <StyledCompetitionTitle>{competitionTitle}</StyledCompetitionTitle>
    <FmTCompetitorsList competitorsListData={competitorsListData} />
  </StyledGroupedList>
)

export default GroupedCompetitorsItem
